// PATTERN CONSTANTS
const EMAIL_VALIDATION_PATTERN = '^[0-9a-zA-Z-._+]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,12}$';
const MOBILE_NUMBER = '^5[0-9]*$';
const MOBILE_NUMBER_DIGITS = '^[0-9]{9}$';
const NAMES_CHARS = '^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.\'-]+$';

// END PAGE
const END_PAGE_TITLE = 'Great! We\'ll see you on the designated day to finalise the process! Thank you.';

export {
  // PATTERN EXPORTS
  EMAIL_VALIDATION_PATTERN,
  MOBILE_NUMBER,
  MOBILE_NUMBER_DIGITS,
  // END PAGE
  END_PAGE_TITLE,
  NAMES_CHARS,
};
